export const theme = {
  light: {
    colorPrimary: `#88ca9e`,
    colorGrad1: `#b4e198`,
    colorGrad2: `#82a98e`,

    colorGreyLight1: `#f9f5f3`, // Light background
    colorGreyLight2: `#f2efee`, // Light lines
    colorGreyLight3: `#d3c7c3`, // Light text (placeholder)
    colorGreyDark1: `#615551`, // Normal text
    colorGreyDark2: `#918581`, // Lighter text
    resutBackground: "#ffff",
    bgColorMode: "#FFBF71",
    textColor: "#000",
    gradient: `linear-gradient(to right bottom, #b4e198   , #82a98e)`,
    gradient2: ` linear-gradient(to right bottom, #b4e19880, #82a98e5d)`
  },
  dark: {
    colorPrimary: `#5878a5`,
    colorGrad1: `#526d82`,
    colorGrad2: `#64889e`,
    colorGreyLight1: `#1c1c28`, // Light background
    colorgreyLight2: `#292938`, // Light lines
    colorgreyLight3: `#5c5351`, // Light text (placeholder)
    colorGreyDark1: `#ffffff`, // Normal text
    bgColorMode: "#423966",
    colorGreyDark2: `#b8ada8`, // Lighter text
    resutBackground: "#24232c",
    textColor: "#fff",
    gradient2: `linear-gradient(to right bottom, #526d8274, #64889e72)`,
    gradient: `linear-gradient(to right bottom, #526d82, #64889e)`
  }
};
